// store/store.ts (Vue 3 / Vuex 4 Version)

import { createStore, Store } from 'vuex'; // Import createStore
// import Vue from 'vue'; // No longer needed for Vuex initialization
import MapModule, { MapState } from "./modules/MapModule";
import BaseMapStylesModule, { BaseMapStylesState } from "../.././base_map_dialog/store/modules/BaseMapStylesDialogModule";
import WaypointDialogModule, { WaypointDialogState } from "../../waypoint_dialog/store/module/WaypointOptionsDialogModule";
// ... other module imports ...
import BaseMapDataOverlaysModule, {BaseMapDataOverlaysState} from "../../base_map_dialog/store/modules/./BaseMapDataOverlaysModule";
import BaseMapDataPOIsModule, {BaseMapDataPOIsState} from "../../base_map_dialog/store/modules/BaseMapDataPOIsModule";
import HikeMeasurementModule, { HikeMeasurementState } from "../../hike_map/store/modules/HikeMeasurementModule";

// RootState definition remains the same
export interface RootState {
  map: MapState,
  mapStyles: BaseMapStylesState,
  waypoints: WaypointDialogState,
  mapDataOverlays: BaseMapDataOverlaysState,
  mapDataPOIs: BaseMapDataPOIsState,
  hikeMeasurement: HikeMeasurementState,
  // ... other state types
}

// Use createStore instead of new Vuex.Store
const store: Store<RootState> = createStore({ // Use createStore
  modules: {
    // Module instantiation remains the same if they follow the Module interface
    map: MapModule,
    mapStyles: BaseMapStylesModule,
    waypoints: WaypointDialogModule,
    mapDataOverlays: BaseMapDataOverlaysModule,
    mapDataPOIs: BaseMapDataPOIsModule,
    hikeMeasurement: new HikeMeasurementModule(),
    // ... other modules
  }
});

export default store;
